/**
 * The account workspace's stream is its PRIMARY sub-account's — the account's own space, which
 * may attach client topics (the account-tree inheritance). Exactly one row per account carries
 * `isPrimary` (DB-enforced), so this only throws on a corrupt tree.
 */
export function primarySubaccount<T extends { id: string; isPrimary: boolean }>(
  subaccounts: T[],
): T {
  const primary = subaccounts.find((sub) => sub.isPrimary)
  if (!primary) throw new Error('This account has no primary sub-account.')
  return primary
}
